// extracted by mini-css-extract-plugin
export default {"container":"Details_container__HP+2U","inputs":"Details_inputs__2LFj1"};